import Postgres from "./connectors/postgresql_elephant.svg?react";
import ImageAddWorkspace from "./Image_add_workspace.svg?react";
import ImageTeamCollaboration from "./Image_team_collaboration.svg?react";
import NoCustomModels from "./no-custom-models.svg?react";
import StartupCustomerService from "./vctrly-startup-customer_service.svg?react";
import StartupDesktop from "./vctrly-startup-desktop.svg?react";
import IdeaBook from "./vctrly-startup-ideabook.svg?react";
import Infographic from "./vctrly-startup-infographic-chart.svg?react";
import StartupEmptyPromptbook from "./vctrly-startup-man-laptop-wfh 1.svg?react";
import StartupTeamwork from "./vctrly-startup-teamwork-2.svg?react";
import Snowflake from "./connectors/snowflake.svg?react";
import MicrosoftFabric from "./connectors/microsoft_fabric.svg?react";

export const Illustrations = {
  IdeaBook,
  Infographic,
  ImageAddWorkspace,
  ImageTeamCollaboration,
  NoCustomModels,
  StartupCustomerService,
  StartupDesktop,
  StartupEmptyPromptbook,
  StartupTeamwork,
  Postgres,
  Snowflake,
  MicrosoftFabric,
};
